module.exports = __webpack_public_path__ + "static/media/johnnys_classic_bowl.d73ad227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/johnnys_classic_bowl.jpg
// module id = 160
// module chunks = 0